"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_1 = require("../../graphql");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importStar(require("react"));
const index_1 = require("./hooks/index");
exports.ContentConversionLoader = () => {
    const { pathParams } = index_1.useConversionCanvas();
    const variables = react_2.useMemo(() => {
        return {
            id: parseInt(pathParams.contentConversionId, 10),
        };
    }, [pathParams.contentConversionId]);
    return (react_2.default.createElement(react_1.OsmosysCanvasPageQueryLoader, { name: "contentConversion", query: graphql_1.contentConversion, variables: variables }));
};
//# sourceMappingURL=Loader.js.map